import{setNonEnumProp}from"../../utils/descriptors.js";

import{callStaticMethod}from"./call.js";

































export const addAllStaticMethods=(plugins,ErrorClass)=>{
plugins.forEach((plugin)=>{
addStaticMethods(plugin,plugins,ErrorClass)
})
};

const addStaticMethods=(plugin,plugins,ErrorClass)=>{
Object.entries(plugin.staticMethods).forEach(
addStaticMethod.bind(undefined,{plugin,plugins,ErrorClass})
)
};

const addStaticMethod=(
{plugin,plugins,ErrorClass},
[methodName,methodFunc])=>
{
setNonEnumProp(
ErrorClass,
methodName,
callStaticMethod.bind(undefined,{
methodFunc,
plugin,
plugins,
ErrorClass
})
)
};